import React from 'react'

export default function Newsletter() {
  return (
    <div>
      
    </div>
  )
}
